
import ApiService from '@/services/configs/api.service'

const PackService = {

    get() {
      return ApiService.get("packs");
    },
   
   
    create(params) {
      return ApiService.post("admin/packs", params);
    },

    update(slug, params) {
      return ApiService.put(`admin/packs/${slug}`,params);
    },

    destroy(slug) {
      return ApiService.delete(`admin/packs/${slug}`);
    },
    getOnePack(slug) {
      return ApiService.get(`packs/${slug}`)
    },
    getOneGrille(slug) {
      return ApiService.get(`grilleTarifaires/${slug}`)
    }



  };

  

  export default  PackService  ;
  